import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NotifyUsersBy, OrderStatus } from '../../constants/KRollConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { ShippingService } from '../../services/api-services/shipping.service';
import { FormService } from '../../services/form.service';
import { arrayMinLengthByKey } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-notification-popup',
  templateUrl: './notification-popup.component.html',
  styleUrls: ['./notification-popup.component.scss']
})
export class NotificationPopupComponent implements OnInit {
  result: { isResult: boolean, pendingPayments: any[], processedPayments: any[] } = {
    isResult: false,
    pendingPayments: [],
    processedPayments: []
  }
  isLoading: boolean = false;
  tenant: any = localStorage.getItem('tenant')
  payload: { orders: 'sale' | 'processed', NotifyUsers: boolean, PaymentOrders: Array<any>, NotifyUsersBy: Array<number> } = {
    orders: this.getOrderType,
    NotifyUsers: true,
    PaymentOrders: [],
    NotifyUsersBy: []
  }
  OrderStatus = OrderStatus;
  form!: FormGroup;
  response: any;
  constructor(public dialogRef: MatDialogRef<NotificationPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any,
    private shippingService: ShippingService,
    public krollService: KRollService,
    public router: Router,
    public toast: ToastrService,
    public validationMessagesService: ValidationMessagesService,
    public fb: FormBuilder,
    private formService: FormService
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.payload.orders = this.getOrderType;
      }
    });
    this.initializeNotifyForm();
  }

  ngAfterViewInit() {
    this.payload.orders = this.getOrderType;
  }

  get emptyUsers() {
    let users = this.props.orders.filter((m: any) => m.UserID == 0);
    return users.length > 0 ? users : [];
  }
  get orderIds() {
    return this.props.orders.map((m: any) => m.OrderID).join(", ");
  }
  get countPendingOrders() {
    return this.props.orders.filter((f: any) => (f.SalesOrderStatus == OrderStatus.WaitingForPayment) || (f.SalesOrderStatus == OrderStatus.Unpaid));
  }
  get ordersWithPayNow() {
    return this.props.orders.filter((item: any) => item.IsAutoPay).length;
  }
  get getOrderType() {
    if (!this.router || !this.router.url) {
      return 'sale';
    }
    
    if (this.router.url.match('/portal/shipping')) {
      return 'sale';
    }
    else if (this.router.url.match('/portal/orders')) {
      return 'processed';
    }
    return 'sale';
  }
  onCheckChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.addNotifyControl();
    }
    else {
      this.form.removeControl('NotifyUsersBy');
    }
  }

  onProceedClick() {
    if (this.isLoading) {
      return;
    }
    if (this.form.valid) {
      this.payload.PaymentOrders = this.props.orders.map((m: any) => {
        return {
          "SalesOrderID": m.ID,
          "OrderID": m.OrderID,
          "UserID": m.UserID,
          "Amount": m.PaymentDue,
          "IsAutoPay": m.IsAutoPay,
          "PayWith": "card"
        }
      }).filter((f: any) => f.Amount > 0);
      this.payload.NotifyUsers = this.form.value.NotifyUsers;
      if (this.form.value.NotifyUsersBy?.length > 0) {
        this.payload.NotifyUsersBy = this.form.value.NotifyUsersBy.filter((f: any) => f.isChecked).map((m: any) => m.id);
      }
      this.isLoading = true;
      this.krollService.sales_order_process_payment(this.payload).subscribe(res => {
        this.response = res;
        if (res.body.success) {
          this.props.patientList.splice(0, this.props.patientList.length);

          this.krollService.get_sales_order_status({ server_location: this.formService.selectedLocation.value });
          //this.toast.success(res.body.message[0]);
          this.result.pendingPayments = res.body.data.pending_payments;
          this.result.processedPayments = res.body.data.processed_payments;
          this.result.isResult = true;
          this.isLoading = false;
        }
        else {
          this.isLoading = false;
          this.toast.error(res.body.message[0]);
        }
      }, err => {
        this.isLoading = false;
        this.toast.error(err.message[0]);
      });
    }
    else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }

  // onProceedClick() {
  //   if (this.form.valid) {
  //     // Map orders and add cardFrom internally
  //     this.payload.PaymentOrders = this.props.orders.map((m: any) => {
  //       console.log("Mapped Order:", m);
  //       return {
  //         "SalesOrderID": m.ID,
  //         "OrderID": m.OrderID,
  //         "UserID": m.UserID,
  //         "Amount": m.PaymentDue,
  //         "IsAutoPay": m.IsAutoPay,
  //         "PayWith": "card",
  //         "cardFrom": m.cardFrom || ""   // internal use only
  //       };
  //     }).filter((f: any) => f.Amount > 0);
  //     // Debug: full payload with cardFrom (internal only)
  //     console.log("Internal Payload (with cardFrom):", this.payload);
  //     // Split by cardFrom
  //     const monerisOrders = this.payload.PaymentOrders.filter(o => o.cardFrom == "moneris");
  //     const normalOrders = this.payload.PaymentOrders.filter(o => o.cardFrom != "moneris"); 
  //     const apiCalls = [];
  //     console.log("Moneris Orders:", monerisOrders);
  //     console.log("Normal Orders:", normalOrders);
  //     if (monerisOrders.length > 0) {
  //       // remove cardFrom before sending
  //       const monerisPayload = {
  //         ...this.payload,
  //         PaymentOrders: monerisOrders.map(({ cardFrom, ...rest }) => rest),
  //         cardFrom: "moneris"
  //       };
  //       console.log("Moneris Payload (final):", monerisPayload);
  //       apiCalls.push(this.krollService.sales_order_process_payment(monerisPayload));
  //     }
  //     if (normalOrders.length > 0) {
  //       // remove cardFrom before sending
  //       const normalPayload = {
  //         ...this.payload,
  //         PaymentOrders: normalOrders.map(({ cardFrom, ...rest }) => rest),
  //         cardFrom: ""
  //       };
  //       console.log("Normal Payload (final):", normalPayload);
  //       apiCalls.push(this.krollService.sales_order_process_payment(normalPayload));
  //     }
  //     if (apiCalls.length > 0) {
  //       this.isLoading = true;
  //       forkJoin(apiCalls).subscribe(res => {
  //         this.response = res;
  //         console.log("All API res:", res);
  //         this.isLoading = false;
  //         res.forEach((res: any) => {
  //           if (res.body.success) {
  //             this.result.pendingPayments = [ ...(this.result.pendingPayments || []), ...(res.body.data.pending_payments || []) ];
  //             this.result.processedPayments = [ ...(this.result.processedPayments || []), ...(res.body.data.processed_payments || []) ];
  //             this.result.isResult = true;
  //           } else {
  //             this.toast.error(res.body.message[0]);
  //           }
  //         });
  //       }, err => {
  //         this.isLoading = false;
  //         this.toast.error(err.message || "Something went wrong");
  //       });
  //     }
  //   } else {
  //     this.validationMessagesService.validateAllFormFields(this.form);
  //   }
  // }

  initializeNotifyForm() {
    let { NotifyUsers } = this.payload;
    this.form = this.fb.group({
      NotifyUsers: new FormControl(NotifyUsers),
    });
    if (NotifyUsers) {
      this.addNotifyControl();
    }
  }

  get notifyByArray() {
    return this.form.get('NotifyUsersBy') as FormArray;
  }

  private addNotifyControl() {
    this.form.addControl('NotifyUsersBy', this.fb.array([], arrayMinLengthByKey(1, 'isChecked')));
    NotifyUsersBy.forEach((x: any) => {
      this.notifyByArray.push(this.fb.group({
        id: new FormControl(x.id),
        value: new FormControl(x.value),
        isChecked: new FormControl(x.isChecked),
        disable: new FormControl(this.tenant == 'sl' ? true : false)
      }));
    });
  }

  continue() {
    this.dialogRef.close({ payload: this.props.payload, response: this.response.body });
  }
}
